/**
 * Quote-card layout for Nationwide CareMatters II (fundingPolicyType 2919).
 *
 * Labels follow the "Your policy highlights" page of the carrier illustration,
 * so an advisor can match each card row to the PDF. Benefit Type is the one row
 * the illustration does not print; it is kept under our own label.
 *
 * Class shows the tobacco status alone. params.riskClass holds the quoting
 * tool's longer label ("Standard Non-Tobacco"), which is not what the
 * illustration prints, so it is not used here.
 *
 * The premium row is "Guaranteed Premium" for both single pay and 10-pay. The
 * payment schedule is already on the face of the card.
 */

import {
  benefitPeriod,
  benefitType,
  currency,
  inflationOption,
  monthlyBenefit,
  premium,
  tobaccoClass,
} from './fieldBank';
import type { QuoteCardLayout } from './types';

export const careMattersIILayout: QuoteCardLayout = [
  {
    title: 'Initial LTC Benefit Limit',
    fields: [
      monthlyBenefit('Maximum Monthly LTC Benefit Day 1'),
      currency('Total LTC Benefit Day 1', quote => quote.ltcBenefitTotal),
      benefitPeriod('LTC Specified Benefit Period', 'years'),
      currency(
        'Guaranteed Minimum Death Benefit',
        quote => quote.deathBenefitMinimumGuaranteedIndividual,
      ),
      currency('Specified Amount', quote => quote.deathBenefitInitial),
    ],
  },
  {
    title: 'Features and Benefits',
    fields: [
      benefitType('Benefit Type'),
      inflationOption('Inflation Protection Option'),
      tobaccoClass('Class'),
    ],
  },
  {
    title: 'Premium',
    fields: [premium('Guaranteed Premium')],
  },
];
